<template>
  <Page>
    <template #title>Информация</template>

    <PageContent>
      <p class="mb-4">
        Детальную информацию о работе с веб-формой можно узнать в Инструкции
        пользователя:
        <a
          :href="downloadManualLink"
          target="_blank"
          class="text-trueBlue underline"
        >
          Скачать
        </a>
      </p>

      <p class="mb-4">
        Веб-форма предназначена для сбора и уточнения данных о мерах социальной
        защиты (поддержки), привязки мер к жизненными ситуациям, определения
        условий назначения по мерам и категориям получателей.
      </p>

      <div class="mb-4">
        В веб-форме используются три жизненные ситуации:
        <ul class="list-disc pl-4 pt-1">
          <li class="mb-1">Установление инвалидности;</li>
          <li class="mb-1">Рождение ребенка;</li>
          <li class="mb-1">Наступление пенсионного возраста.</li>
        </ul>
      </div>

      <div class="mb-4">
        В зависимости от режима работы и полномочий в веб-форме предусмотрена
        работа следующих ролей и выполняемых ими функций:
        <ul class="list-disc pl-4 pt-2 mb-6">
          <li class="mb-2">
            Поставщик информации (ПИ) – выполняет функциональность, связанную с
            заполнением жизненной ситуации и условий по ЛМСЗ, и не включающую
            функцию согласования и изменения статуса ЛМСЗ, взаимодействует в
            процессе ведения реестра ЛМСЗ для информирования с уполномоченным
            органом;
          </li>
          <li class="mb-2">
            Уполномоченный орган (УО) – уполномоченный орган с функцией согласования
            ЛМСЗ по поступающим заявкам от ПИ своего субъекта. Выполняет функцию
            по включению и исключению ЛМСЗ по заявкам от ПИ в веб-форме;
          </li>
          <li class="mb-2">
            Особый Уполномоченный орган (ОУО) - выполняет весь спектр функций,
            связанных с привязкой ЛМСЗ к жизненной ситуации и заполнением
            условий, включению и исключению ЛМСЗ из информирования в веб-форме
            по всем мерам поставщиков информации региона. Поставщиком информации
            не осуществляется работа веб-форме (только в КПИ), все функции
            выполняет ОУО.
          </li>
        </ul>
      </div>
    </PageContent>

    <template #footer>
      <router-link :to="toRequestsRoute" v-slot="{navigate}">
        <BaseButton size="md" variant="blue" @click="navigate">
          Перейти к Реестру ЛМСЗ
        </BaseButton>
      </router-link>
    </template>
  </Page>
</template>

<script>
  import {mapGetters} from 'vuex';

  import Client from '@/classes/Api/Client';

  import Page from '@/components/layouts/main/page';
  import BaseButton from '@/components/global/base-button';
  import PageContent from '@/components/layouts/main/page/PageContent';

  export default {
    name: 'InfoPage',

    components: {
      Page,
      BaseButton,
      PageContent,
    },

    computed: {
      ...mapGetters('Auth', ['hasRole']),

      downloadManualLink() {
        return Client.getDownloadManualUrl();
      },

      toRequestsRoute() {
        if (this.hasRole('head')) {
          return {name: 'head.register'};
        }
        return {name: 'registry'};
      },
    },
  };
</script>
